import { filterOutEmpty } from './array';

export function cleanInfoItems(items?: string[]) {
	if (!items) {
		return undefined;
	}

	return filterOutEmpty(items).map((item) => item.trim());
}
